import {Attribute} from '../../components/ObjectAttribute';
import importRequest from "./requests/importRequest";
import exportRequest from "./requests/exportRequest";
import exportHeaderRequest from "./requests/exportHeaderRequest";
import dataQueryBody from "./requests/dataQueryBody";
import dataQueryParam from "./requests/dataQueryParam";
import {RequestDefinitionData} from "../../components/RequestDefinition";
import importRequestJson from "./requests/importRequestJson";

const importExportEndpoints: RequestDefinitionData[] = [
    importRequest,
    importRequestJson,
    exportRequest,
    exportHeaderRequest,
    dataQueryBody,
    dataQueryParam,
];

export const importExportHeader = {
    title: 'Imports and Exports',
    description: 'This handles importing and exporting data from CSV files. ' +
        'In the request, the name parameter should be replaced by the case-sensitive default name of the CSV import/export with "-" replacing any spaces. ' +
        'Example: Sales Order Details -> Sales-Order-Details',
    linkName: 'Imports and Exports',
    link: 'https://help.fishbowlinventory.com/hc/en-us/articles/360043109853-Imports-and-Exports',
    endpoints: importExportEndpoints,
};

export const importExportAttributes: Attribute[] = [];
